export default __webpack_public_path__ + "static/media/carticon.d2a1d193.svg";